/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Favorite_Projects_TitleInputs */



/**
* | output |
* | --- |
* | "Favorite projects" |
*
* @param {Onboarding_Tour_Favorite_Projects_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_favorite_projects_title = /** @type {((inputs?: Onboarding_Tour_Favorite_Projects_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Favorite_Projects_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Favorisierte Projekte")
	return /** @type {LocalizedString} */ ("Favorite projects")
});